var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.glyph)?_c('cms-component',_vm._b({class:{'standalone': _vm.component.standalone},style:(_vm.containerStyle),attrs:{"link":_vm.component.link}},'cms-component',_vm.$props,false),[_c('i',{staticClass:"glyph-component fa-fw",class:[_vm.fontAwesomePrefix, _vm.glyph],style:(_vm.glyphStyle)})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }